import { initializeApp } from "firebase/app";
import { getFirestore }  from "firebase/firestore";

const c = {
  apiKey: "AIzaSyCMC3MGF5d1ehpCIWhG1ssMOsrdAp9tCFE",
  authDomain: "auth.hellosincerely.com",
  projectId: "books-378423",
  storageBucket: "books-378423.appspot.com",
  messagingSenderId: "262963712307",
  appId: "1:262963712307:web:afb58525d3ece7eb1eae46"
};

const f = initializeApp(c);
export default getFirestore(f);
